import React, { Component } from 'react'
import LabelError from '../LabelError'
import Label from '../Label'

export default class SelectField extends Component {

    render() {
        const {
            name,
            label,
            required,
            list,
            value,
            isDisabled,
            error,
            errorDisabled = false,
        }  = this.props
        return (
            <div className="flex flex-col justify-center align-top ">
                <Label name={ name } label={ label } type="select"  required={ required } />
                {isDisabled && (
                    <div className="border px-3 py-1 bg-gray-200 text-left text-gray-400">
                        ...
                    </div>
                )}
                {!isDisabled && (
                    <select
                        name={name}
                        defaultValue={value}
                        onChange={this.props.onChange}
                        className="bg-zinc-100 p-2 text-black"
                        disabled={isDisabled}
                        >
                        <option 
                            aria-label="empty" 
                            key="empty" 
                            value="" 
                            disabled={isDisabled}
                        >
                            ...
                        </option>
                        {list.map(item => (
                            <option
                                key={`${item.value}`}
                                value={item.value}
                                disabled={isDisabled}
                            >
                                {item.label}
                            </option>
                        ))}
                    </select>
                )}
                <LabelError error={error} errorDisabled={errorDisabled} name={name} value={value} />
        </div>
        )
    }
}
